import { forwardRef } from 'react';
import { loadable } from '@Components/Utilities/SandhillsLoadable';

const Autocomplete = loadable(() => import('@Components/MuiWrappers/Autocomplete'));
const CityStateZipAutocomplete = loadable(() => import('@Components/MuiWrappers/CityStateZipAutocomplete'));

const Combobox = forwardRef((props, ref) => {
    const {
        getOptionIcon,
        getOptionLabel,
        label,
        name: nameProp,
        onChange,
        onBlur,
        helperText,
        options: optionsProp,
        renderOption,
        value: valueProp,
        onOpen,
        styles,
        id,
        width,
        textFieldStyles,
        disableClearable,
        disabled,
        popperStyles,
        isOptionEqualToValue,
        popperDisablePortal
    } = props;

    if (props.IsCityStateZip) {
        return (
            <CityStateZipAutocomplete
                ref={ref}
                ajaxOptions={{ enabled: true }}
                freeSolo={true}
                getOptionLabel={getOptionLabel}
                label={label}
                name={nameProp}
                onChange={onChange}
                onBlur={onBlur}
                helperText={helperText}
                options={optionsProp}
                searchOptions={{ enabled: false }}
                tracking={{ enabled: false }}
                value={valueProp}
                renderOption={renderOption}
                inputOptions={{ startAdornment: getOptionIcon }}
                useAutoSuggestHighlight={false}
                onOpen={onOpen}
                styles={styles}
                id={id}
                width={width}
                disableClearable={disableClearable}
                textFieldStyles={textFieldStyles}
                disabled={disabled}
                popperStyles={popperStyles}
                isOptionEqualToValue={isOptionEqualToValue}
            />
        );
    } else {
        return (
            <Autocomplete
                ref={ref}
                ajaxOptions={{ enabled: false }}
                freeSolo={false}
                getOptionLabel={getOptionLabel}
                label={label}
                name={nameProp}
                onChange={onChange}
                onBlur={onBlur}
                helperText={helperText}
                options={optionsProp}
                searchOptions={{ enabled: false }}
                tracking={{ enabled: false }}
                value={valueProp}
                renderOption={renderOption}
                inputOptions={{ startAdornment: getOptionIcon }}
                useAutoSuggestHighlight={false}
                onOpen={onOpen}
                styles={styles}
                id={id}
                width={width}
                disableClearable={disableClearable}
                textFieldStyles={textFieldStyles}
                disabled={disabled}
                popperOptions={{ disablePortal: popperDisablePortal, styles: popperStyles }}
                isOptionEqualToValue={isOptionEqualToValue}
            />
        );
    }
    
});

export default Combobox;